import { Slide, TextProps } from '@features/powerpoint';
import { ValueInput } from '@utils/formattersV2';
import {
  dimensionMetrics,
  PerformanceMetricsGetter,
  SalesDimensionsSlideBaseOptions,
} from './content';
import { theme } from '@features/executive-report/domain/theme';
import { contentSlideTitleText } from '../content-slide-title-text';
import {
  applyDimensionXOffset,
  applyDimensionMetricYOffset,
  applyDimensionYOffset,
} from '@features/executive-report/dimensions/layout';
import {
  recommendationText,
  blueDimensionBoxText,
  overallPerformanceText,
} from '@features/executive-report/dimensions/texts';

export const OVERALL_LINE_ITEM_OFFSET = 0.79;

export type OverallLineItemTextsOptions = {
  label: string;
  formattedValue: string;
  lift?: number;
  liftFormatter?: (value: ValueInput) => string;
  index: number;
};

type TextsOptions = SalesDimensionsSlideBaseOptions;

// TODO: Refactor the arguments to be an object instead of a list of arguments
export const texts = (
  options: TextsOptions,
  headerTabs: TextProps[],
  overallLineItemTexts: (
    options: OverallLineItemTextsOptions
  ) => NonNullable<Slide['texts']>,
  getPerformanceMetrics?: PerformanceMetricsGetter
): NonNullable<Slide['texts']> => {
  return [
    ...headerTabs,
    contentSlideTitleText(options.titleText),
    recommendationText(options.recommendation),
    overallPerformanceText,
    ...options.overallMetrics.flatMap((overallMetric, index) =>
      overallLineItemTexts({ ...overallMetric, index })
    ),
    blueDimensionBoxText(options.dimensionName, options.subdimensions.length),
    ...options.subdimensions.flatMap((subdimension, index) => [
      {
        text: subdimension.name,
        options: {
          fontSize: 11,
          color: theme.colors.white,
          h: 0.29,
          w: 2.27,
          x: 4.35 + applyDimensionXOffset(index),
          y: 3.02 + applyDimensionYOffset(index),
        },
      },
      ...(subdimension.image
        ? []
        : [
            {
              text: (index + 1).toString(),
              options: {
                fontSize: 32,
                color: theme.colors.inmarketGreen,
                h: 0.64,
                w: 0.36,
                x: 4.83 + applyDimensionXOffset(index),
                y: 3.54 + applyDimensionYOffset(index),
              },
            },
            {
              text: (
                subdimension.placeholder ?? options.dimensionName
              ).toUpperCase(),
              options: {
                fontSize: 12,
                color: theme.colors.white,
                bold: true,
                h: 0.28,
                w: 1.21,
                x: 5.19 + applyDimensionXOffset(index),
                y: 3.74 + applyDimensionYOffset(index),
              },
            },
          ]),
      ...(getPerformanceMetrics ?? dimensionMetrics)(subdimension).flatMap(
        (metric, metricIndex): NonNullable<Slide['texts']> => [
          {
            text: metric.label.toUpperCase(),
            options: {
              fontSize: 8,
              color: theme.colors.white,
              h: 0.24,
              w: 1.46,
              x: 4.28 + applyDimensionXOffset(index),
              y:
                4.52 +
                applyDimensionYOffset(index) +
                applyDimensionMetricYOffset(metricIndex),
            },
          },
          {
            text: metric.value,
            options: {
              fontSize: 12,
              color: theme.colors.inmarketGreen,
              h: 0.3,
              w: 1.51,
              x: 5.6 + applyDimensionXOffset(index),
              y:
                4.49 +
                applyDimensionYOffset(index) +
                applyDimensionMetricYOffset(metricIndex),
            },
          },
        ]
      ),
    ]),
  ];
};
